import { useT } from "../../shared/i18n";
import { Banner, Button } from "../../shared/ui";

/** An error banner that always offers a retry. */
export function ErrorRetry({
  message,
  onRetry,
}: {
  message: string;
  onRetry: () => void;
}) {
  const t = useT();
  return (
    <Banner
      tone="error"
      action={
        <Button variant="secondary" onClick={onRetry}>
          {t("admin.retry")}
        </Button>
      }
    >
      {message}
    </Banner>
  );
}
